import React, { createContext, useContext, useState } from 'react';

const ErrorContext = createContext();

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export const ErrorProvider = ({ children }) => {
  const [forbiddenError, setForbiddenError] = useState({
    isOpen: false,
    message: ''
  });

  const showForbiddenError = (message) => {
    setForbiddenError({
      isOpen: true,
      message
    });
  };

  const hideForbiddenError = () => {
    setForbiddenError({
      isOpen: false,
      message: ''
    });
  };

  const resetError = () => {
    setForbiddenError({
      isOpen: false,
      message: ''
    });
  };

  return (
    <ErrorContext.Provider value={{
      forbiddenError,
      showForbiddenError,
      hideForbiddenError,
      resetError
    }}>
      {children}
    </ErrorContext.Provider>
  );
};